import { useState } from "react";
import { PromptTemplateVar } from "../../../api";
import { defaultProcessingMessage, EditVarsModalContentProps, ProcessVarProps, UtilizeModalContentProps, VarElementFactory } from "./VarElementFactory";
import { ChoiceGroup, DefaultButton, IChoiceGroupOption, IconButton, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";

const EditVarsModalContent_AddFile = (props: EditVarsModalContentProps) => {
    const {focusElement, vars, onVarsChanged, backToList} = props
        const [name, setName] = useState(focusElement?.name ?? "")
        const [required, setRequired] = useState<string>(focusElement ? (focusElement?.is_required ? "required" : "not_required") : "")

    const options: IChoiceGroupOption[] = [
        { key: 'required', text: '必須' },
        { key: 'not_required', text: '任意' },
    ];
    const opeType = focusElement ? "修正" : "追加"

    return (
        <form onSubmit={(e) => {
            if (!e.currentTarget.checkValidity()) {
              return
            }
            e.preventDefault()
            const newVar: PromptTemplateVar = {
                id: focusElement?.id ?? window.crypto.randomUUID(),
                name: name,
                description: "",
                is_required: required === "required",
                input_type: "File",
                elements: []
            }
            // 修正
            if(focusElement){
                const newVars = vars.map(v => v.id === newVar.id ? newVar : v)
                onVarsChanged(newVars)
            }
            // 追加
            else {
                const newVars = [...vars]
                newVars.push(newVar)
                onVarsChanged(newVars)
            }
            backToList()
        }}>
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" id="editvarsmodalcontent-header">
                <h2>
                  {`質問項目の${opeType} (ファイル)`}
                </h2>
                <IconButton
                  iconProps={{iconName: 'Cancel'}}
                  onClick={backToList}
                />
            </Stack>
            <Stack id="editvarsmodalcontent-body" tokens={{childrenGap: "15px"}} style={{maxHeight: "70vh", minHeight: "70px", overflowY: "auto"}}>
                <TextField 
                    label="質問内容" 
                    style={{width: "100%"}} 
                    maxLength={1024}
                    required 
                    placeholder="例：請求書を撮影してアップロードしてください"
                    value={name}
                    onChange={(e) => setName(e.currentTarget.value)}
                />
                <ChoiceGroup 
                    options={options} 
                    label="入力条件" 
                    required 
                    selectedKey={required}
                    onChange={(_, option) => setRequired(option?.key ?? "") }/>
                <Stack horizontal tokens={{childrenGap: "26px"}} style={{marginTop: "20px", marginBottom: "20px"}}>
                    <PrimaryButton text={opeType} type="submit" style={{width: "120px"}} />
                    <DefaultButton text="キャンセル" style={{width: "120px"}} onClick={backToList} />
                </Stack>
            </Stack>
        </form>
    )
}

const VarElement_File = (props: UtilizeModalContentProps) => {
    const { templateVar } = props
    return (<>
      <Label>{templateVar.name + (templateVar.is_required ? " *" : "")}</Label>
      <input type="file" name={templateVar.id} style={{marginTop: "0px"}} required={props.templateVar.is_required} multiple />
    </>)
}

const processFileVar = async (props: ProcessVarProps) => {
    const {requestPrompt, templateVar, onChangeRequestPrompt, element, onFileAdded} = props
    if (element && element.files) {
      for (const file of element.files) {
        onFileAdded(file)
      }
    }
    const newReq = requestPrompt.replaceAll(`{{${templateVar.id}}}`, "")
    onChangeRequestPrompt(newReq)
}

export const FileVarElementFactory: VarElementFactory = {
    inputType: "File" as const,
    itemName: "ファイル入力",
    isDroppableToRequest: false,
    iconName: "Attach",
    editVarsModalContent: EditVarsModalContent_AddFile,
    utilizeModalContent: VarElement_File,
    processVar: processFileVar,
    processingMessage: defaultProcessingMessage
}